/**
 * Format tiền tệ riêng cho feature Revenue
 * Format: 1.234,99 € (không có space trước €, dấu . phân cách hàng nghìn, dấu , phân cách thập phân)
 */
export const formatCurrencyRevenue = (value = 0) => {
    const num = parseFloat(value) || 0;
    const [intPart, decPart = ''] = num.toFixed(2).split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${formattedInt},${decPart} €`;
};
